export default function ProcessNotice() {
  return (
    <section className="w-full py-14" style={{ backgroundColor: '#f4faf8' }}>
      <div className="max-w-5xl mx-auto px-6 space-y-8">

        {/* 꼭 기억하세요 배너 */}
        <div
          className="rounded-2xl p-6 md:p-8"
          style={{ background: 'linear-gradient(135deg, #0d2b24 0%, #1a4a3a 100%)' }}
        >
          <div className="flex items-center gap-3 mb-5">
            <div
              className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
              style={{ backgroundColor: 'rgba(111,207,184,0.2)' }}
            >
              <i className="ri-alarm-warning-line text-xl" style={{ color: '#6fcfb8' }}></i>
            </div>
            <div>
              <p className="text-xs font-bold tracking-widest uppercase" style={{ color: '#6fcfb8' }}>NOTICE</p>
              <h3 className="text-base font-bold text-white">꼭! 기억하세요 — 서비스 이용 핵심 포인트</h3>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              {
                step: '① 회원가입 및 등록',
                items: [
                  '휴대폰 번호로 간편하게 회원가입할 수 있습니다',
                  '환자는 간병 장소(집/병원), 간병 조건을 상세히 등록하세요',
                  '간병인은 경력, 자격증, 가능 지역을 정확히 입력하세요',
                ],
              },
              {
                step: '② 검색 및 매칭 제안',
                items: [
                  '지역, 경력, 시급 등 원하는 조건으로 상대방을 검색하세요',
                  '환자→간병인, 간병인→환자 양방향 매칭 제안이 가능합니다',
                  '프로필을 꼼꼼히 확인하고 신중하게 매칭 제안을 보내주세요',
                ],
              },
              {
                step: '③ 매칭 진행 및 정산',
                items: [
                  '매칭 수락 시 상대방 연락처가 즉시 공개됩니다',
                  '간병비는 양 당사자 간 직접 정산합니다',
                  '간병 완료 후 중개 수수료를 당사에 입금해주세요',
                ],
              },
            ].map((block, i) => (
              <div
                key={i}
                className="rounded-xl p-4"
                style={{ backgroundColor: 'rgba(255,255,255,0.07)' }}
              >
                <p className="text-xs font-bold mb-2" style={{ color: '#6fcfb8' }}>{block.step}</p>
                <ul className="space-y-1">
                  {block.items.map((item, j) => (
                    <li key={j} className="flex items-start gap-1.5 text-xs leading-relaxed" style={{ color: 'rgba(255,255,255,0.75)' }}>
                      <span className="mt-0.5 flex-shrink-0" style={{ color: '#6fcfb8' }}>·</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* 간병일지 다운로드 */}
        <div
          className="rounded-2xl p-6 border"
          style={{ backgroundColor: '#fff', borderColor: 'rgba(46,125,107,0.2)' }}
        >
          <div className="flex items-center gap-2 mb-2">
            <i className="ri-download-2-line text-base" style={{ color: '#2E7D6B' }}></i>
            <h4 className="text-sm font-bold text-gray-900">간병일지 양식 다운로드</h4>
          </div>
          <p className="text-xs text-gray-500 leading-relaxed mb-5">
            보험사별 간병일지 양식은 상이할 수 있으니, <strong className="text-gray-700">생명보험 가입자의 경우 당사로 연락</strong> 부탁드립니다.
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href="https://storage.readdy-site.link/project_files/85651164-9881-44bb-8cd7-002bfdcb405b/5c697202-8ad9-4e34-ac08-218afddde98f_-_.jpg?v=070242f12d6341e7692f61bf2fab374f"
              download="간병일지_코리아케어러스.jpg"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#2E7D6B' }}
            >
              <i className="ri-image-line"></i>간병일지 양식 (JPG) 다운로드
            </a>
            <a
              href="https://storage.readdy-site.link/project_files/85651164-9881-44bb-8cd7-002bfdcb405b/4c16399f-393b-4b34-8cba-ab9c90f2097a_-_.pdf?v=39a1b7db47ac57a7935e46154017abc8"
              download="간병일지_코리아케어러스.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#f0f9f6', color: '#2E7D6B', border: '1px solid #2E7D6B' }}
            >
              <i className="ri-file-pdf-line"></i>간병일지 양식 (PDF) 다운로드
            </a>
          </div>
        </div>

        {/* 고객센터 */}
        <div
          className="rounded-2xl p-6 flex flex-col sm:flex-row items-start sm:items-center gap-5"
          style={{ backgroundColor: '#f0f9f6', border: '1px solid rgba(46,125,107,0.2)' }}
        >
          <div className="w-12 h-12 flex items-center justify-center rounded-2xl flex-shrink-0" style={{ backgroundColor: 'rgba(46,125,107,0.12)' }}>
            <i className="ri-customer-service-2-line text-2xl" style={{ color: '#2E7D6B' }}></i>
          </div>
          <div className="flex-1">
            <p className="text-xs font-semibold text-gray-500 mb-0.5">코리아케어러스 고객센터</p>
            <a href="tel:15668654" className="text-2xl font-black block cursor-pointer hover:opacity-80 transition-opacity" style={{ color: '#2E7D6B' }}>
              1566-8654
            </a>
            <p className="text-xs text-gray-400 mt-0.5">오전 9시 ~ 오후 11시 · 연중무휴</p>
          </div>
          <a
            href="/app"
            className="flex-shrink-0 px-5 py-2.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
            style={{ backgroundColor: '#2E7D6B' }}
          >
            <i className="ri-user-add-line mr-1.5"></i>회원가입 하러가기
          </a>
        </div>

      </div>
    </section>
  );
}